import { render } from "./vaccountset.vue?vue&type=template&id=61ac5950&scoped=true"
import script from "./vaccountset.vue?vue&type=script&lang=js"
export * from "./vaccountset.vue?vue&type=script&lang=js"

import "./vaccountset.vue?vue&type=style&index=0&id=61ac5950&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ac5950"]])

export default __exports__